import _classCallCheck from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createSuper.js";
// Copyright 2017-2022 @polkadot/types-codec authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { CodecMap } from "./Map.js";
export var BTreeMap = /*#__PURE__*/function (_CodecMap) {
  _inherits(BTreeMap, _CodecMap);

  var _super = _createSuper(BTreeMap);

  function BTreeMap() {
    _classCallCheck(this, BTreeMap);

    return _super.apply(this, arguments);
  }

  _createClass(BTreeMap, null, [{
    key: "with",
    value: function _with(keyType, valType) {
      return /*#__PURE__*/function (_BTreeMap) {
        _inherits(_class, _BTreeMap);

        var _super2 = _createSuper(_class);

        function _class(registry, value) {
          _classCallCheck(this, _class);

          return _super2.call(this, registry, keyType, valType, value, 'BTreeMap');
        }

        return _createClass(_class);
      }(BTreeMap);
    }
  }]);

  return BTreeMap;
}(CodecMap);